'use client';

import { type RefObject, useLayoutEffect, useState } from 'react';

// This hook return function focuses first error field within formRef.
// The return function should be called after validation errors are added.
// It won't do anything if there are no errors.

const useFocusFirstErrorComponent = (
  formRef: RefObject<HTMLFormElement | HTMLDivElement | null>,
): (() => void) => {
  const [counter, setCounter] = useState(0);

  // biome-ignore lint/correctness/useExhaustiveDependencies: I think removing counter actually broke it. Worth testing.
  useLayoutEffect(() => {
    const firstErrorComponentWithinForm =
      formRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]');

    if (firstErrorComponentWithinForm) {
      firstErrorComponentWithinForm.focus();
    }
  }, [counter, formRef]);

  return () => {
    setCounter((counter) => counter + 1);
  };
};

export default useFocusFirstErrorComponent;
